export const PROJECTS = 20;
export const LABELS = 20;
export const TODOS = 40;
export const COLORS = 40;
